export const SuggestionIcon = () => (
  <svg
    width="40"
    height="48"
    viewBox="0 0 40 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.8859 1.94531H7.07493C4.24192 1.94531 1.94531 4.24192 1.94531 7.07493V38.2064C1.94531 41.0394 4.24192 43.336 7.07493 43.336H26.8859C29.7189 43.336 32.0155 41.0394 32.0155 38.2064V7.07493C32.0155 4.24192 29.7189 1.94531 26.8859 1.94531Z"
      fill="#503DC9"
    />
    <path
      d="M26.8863 3.89143C27.7307 3.89143 28.5405 4.22688 29.1376 4.82398C29.7347 5.42107 30.0702 6.23091 30.0702 7.07533V38.2068C30.0702 39.0512 29.7347 39.8611 29.1376 40.4582C28.5405 41.0553 27.7307 41.3907 26.8863 41.3907H7.07533C6.23091 41.3907 5.42107 41.0553 4.82398 40.4582C4.22688 39.8611 3.89143 39.0512 3.89143 38.2068V7.07533C3.89143 6.23091 4.22688 5.42107 4.82398 4.82398C5.42107 4.22688 6.23091 3.89143 7.07533 3.89143H26.8863ZM26.8863 0H7.07533C5.19884 0 3.3992 0.745435 2.07232 2.07232C0.745435 3.3992 0 5.19884 0 7.07533V38.2068C0 40.0833 0.745435 41.8829 2.07232 43.2098C3.3992 44.5367 5.19884 45.2821 7.07533 45.2821H26.8863C28.7628 45.2821 30.5624 44.5367 31.8893 43.2098C33.2162 41.8829 33.9616 40.0833 33.9616 38.2068V7.07533C33.9616 5.19884 33.2162 3.3992 31.8893 2.07232C30.5624 0.745435 28.7628 0 26.8863 0Z"
      fill="#937FEF"
    />
    <path
      d="M39.3478 39.1739C39.3478 43.6882 35.6882 47.3478 31.1739 47.3478C26.6596 47.3478 23 43.6882 23 39.1739C23 34.6596 26.6596 31 31.1739 31C35.6882 31 39.3478 34.6596 39.3478 39.1739Z"
      fill="#F470BD"
    />
    <rect x="8" y="22" width="18" height="1.5" fill="#937FEF" />
    <rect x="10" y="26" width="14" height="1.5" fill="#937FEF" />
    <path
      d="M20.885 17.7472C20.885 15.8467 19.343 14.3047 17.4425 14.3047C15.542 14.3047 14 15.8467 14 17.7472H20.885Z"
      fill="white"
    />
    <path
      d="M19.1632 11.7213C19.1632 12.6715 18.3922 13.4425 17.442 13.4425C16.4917 13.4425 15.7207 12.6715 15.7207 11.7213C15.7207 10.771 16.4917 10 17.442 10C18.3922 10 19.1632 10.771 19.1632 11.7213Z"
      fill="white"
    />
    <path
      d="M30.5632 39.9176H28V38.5446H30.5632V36H31.9368V38.5446H34.5V39.9176H31.9368V42.5H30.5632V39.9176Z"
      fill="white"
    />
  </svg>
);
